import React, { useState, useEffect } from "react";
import { useSubheader } from "@metronic/layout";
import { Alert } from "react-bootstrap";
import Pagination from "react-js-pagination";
import GeneralFilter from "@components/shared/general-filter";
import GeneralTable from "@components/shared/general-table";
import { getCasesByStatuses } from "@services/cases";
import CaseContext from "@contexts/case-context";

const ControlDesk = () => {
  window.currModule = "Mesa de Control";
  window.assignationColumn = "feamesaControl";

  const subheader = useSubheader();

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const getAllCasesByStatus = (pageNumber) => {
    getCasesByStatuses([2, 9], pageNumber, ['&byRegion=true', '&byCell=true']).then((response) => {
      setCasesRecord(response.data);
      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);

    subheader.setTitle("Mesa de Control");
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Mesa de Control
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[2, 9]}
          hideInsurance={true}
          hideReason={false}
          hideCategoryVip={true}
          hideHospitalType={false}
          hideHospitalInvoice={true}
          hidePresumptiveDiagnosis={true}
          hideRegion={false}
          hideCell={false}
          showSpecialityFilters={true}
        />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/mesa_control_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        hideAssignedDoctorColumn={true}
        hideAssignedNurseColumn={true}
        hideAssignedConciergeColumn={true}
        hidePatientStatusColumn={true}
        hideCelulaColumn ={false}
        reason="ControlDesk"
        assignationColumn="feamesaControl"
        currModule="Mesa de Control"
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default ControlDesk;

